import styles from "./ChatView.module.scss";
import { View, ViewHeader } from "@/components";

export const ChatView = () => {
  return (
    <View>
      <div className={styles["comp__content"]}>
        <ViewHeader
          heading="Chat"
          description="Keep an eye on live conversations and respond to chat activity in one place.<br />Use this section to manage real-time communication."
        />

        <div className={styles["comp__unavailable"]} role="status">
          <p className={styles["comp__unavailable-title"]}>Chat unavailable</p>
          <p className={styles["comp__unavailable-text"]}>
            Inbox chat is not implemented in this dashboard yet. There is no chat
            API — the previous new-chat control was a no-op and has been removed.
          </p>
        </div>
      </div>
    </View>
  );
};
